import type React from 'react';

import DialogFooterCancelButton from './controls/cancel';
import DialogFooterDeleteButton from './controls/delete';
import DialogFooterOkButton from './controls/ok';

export interface IProps {
  btnCancelClass?: string;
  btnOkClass?: string;
  btnDeleteClass?: string;
  cancelText?: string;
  disabledBtnOK?: boolean;
  disabledBtnCancel?: boolean;
  disabledBtnDelete?: boolean;
  okText?: string;
  showLoadingBtnOK?: boolean;
  showCancel?: boolean;
  showSave?: boolean;

  onOK?: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
}

const DialogFooterFallback: React.FC<IProps> = ({
  btnCancelClass,
  btnOkClass,
  btnDeleteClass,
  cancelText,
  disabledBtnOK,
  disabledBtnCancel,
  disabledBtnDelete,
  okText,
  showLoadingBtnOK,
  showCancel,
  showSave,
  onCancel,
  onOK,
  onDelete
}) => {
  return (
    <>
      {onDelete && (
        <DialogFooterDeleteButton
          className={btnDeleteClass}
          disabled={disabledBtnDelete}
          onDelete={onDelete}
        />
      )}
      {showSave && (
        <DialogFooterOkButton
          className={btnOkClass}
          disabled={disabledBtnOK}
          loading={showLoadingBtnOK}
          value={okText}
          onPress={onOK}
        />
      )}
      {showCancel && (
        <DialogFooterCancelButton
          className={btnCancelClass}
          disabled={disabledBtnCancel}
          loading={showLoadingBtnOK}
          value={cancelText}
          onPress={onCancel}
        />
      )}
    </>
  );
};

DialogFooterFallback.defaultProps = {
  showCancel: true,
  showSave: true,
  disabledBtnOK: false
};

export default DialogFooterFallback;
